import { PagesRoutes } from '../../../../routing/PagesRoutes';

export type ShipmentFormReturnTo = 'consolidation';

export type ShipmentFormNavigationContext = {
    returnTo: ShipmentFormReturnTo;
    consolidationMaster: string;
};

export const consolidationDetailPath = (master: string) =>
    `${PagesRoutes.ShipmentsConsolidations}/${encodeURIComponent(master)}`;

export const newHouseShipmentPath = (master: string) =>
    `${PagesRoutes.NewShipment}?fromConsolidation=${encodeURIComponent(master)}`;

export const editShipmentFromConsolidationPath = (shipmentId: string, master: string) =>
    `${PagesRoutes.EditShipment}/${shipmentId}?fromConsolidation=${encodeURIComponent(master)}`;

export const buildConsolidationNavigationState = (master: string) => ({
    returnTo: 'consolidation' as const,
    consolidationMaster: master
});

export const resolveShipmentFormNavigationContext = (
    state?: Record<string, unknown> | null,
    search?: string
): ShipmentFormNavigationContext | undefined => {
    const params = new URLSearchParams(search || '');
    const fromQuery = params.get('fromConsolidation');
    const master =
        (typeof state?.consolidationMaster === 'string' && state.consolidationMaster.trim()) ||
        (fromQuery?.trim() ? fromQuery.trim() : undefined);

    if (!master) return undefined;

    const returnTo =
        state?.returnTo === 'consolidation' || fromQuery ? ('consolidation' as const) : undefined;

    if (!returnTo) return undefined;

    return { returnTo, consolidationMaster: master };
};
